export default __webpack_public_path__ + "static/media/forti-firewall.f0d42f84.webp";